import { Field } from 'formik'
import { useMemo } from 'react'
import * as Yup from 'yup'
import { useMsg } from '~/common/localizationUtils'
import { FormikFormControl } from '~/components/v2/formik/FormikFormControl'
import VndlySelect from '~/components/VndlySelect'
import { DateTruncPrecision } from '~/custom_reports/types'
import { FieldSelector } from './FieldSelector'

export const DateTruncValidations = {
  fields: Yup.array(
    Yup.object({
      path: Yup.string().required('Source is required').nullable(),
      field: Yup.string().required('Field is required').nullable()
    })
  ).min(1, 'At least one value is required'),
  precision: Yup.string().required('Precision is required').nullable()
}

export const DateTrunc = ({ calculatedField }) => {
  const msg = useMsg()
  const precisionOptions = useMemo(
    () =>
      Object.values(DateTruncPrecision)
        .filter(precision => !(precision === DateTruncPrecision.Second))
        .map(precision => ({
          label: msg(`common.unit_of_measurement.${precision}`),
          value: precision
        })),
    [msg]
  )

  return (
    <>
      <FieldSelector calculatedField={calculatedField} types={['datetime', 'date']} maxFields={1} />

      <FormikFormControl label="Precision">
        <Field name="precision" component={VndlySelect} options={precisionOptions} />
      </FormikFormControl>
    </>
  )
}
